// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"180":"4b61f8e8","788":"71f96082","817":"0a1780c6"}[chunkId] + ".css";
};